export default __webpack_public_path__ + "static/Primary_Endpoint_Chart-LG@2x-cf55fad250b90c1c900ffbbdcb6671f8.png";